
export enum DateRangeToken {
    LAST1H = "LAST1H",
    LAST6H = "LAST6H",
    LAST12H = "LAST12H",
    TODAY = "TODAY",
    YESTERDAY = "YESTERDAY",
    LAST2D = "LAST2D",
    LAST3D = "LAST3D",
    LAST7D = "LAST7D",
    ALLTIME = "ALLTIME",
    DAYMINUS5 = "DAYMINUS5",
    DAYMINUS4 = "DAYMINUS4",
    DAYMINUS3 = "DAYMINUS3",
    DAYMINUS2 = "DAYMINUS2",
    TOMORROW = "TOMORROW",
    DAYPLUS2 = "DAYPLUS2",
    DAYPLUS3 = "DAYPLUS3",
    DAYPLUS4 = "DAYPLUS4",
    DAYPLUS5 = "DAYPLUS5",
    LASTMONTH = "LASTMONTH",
    THISMONTH = "THISMONTH",
    NEXTMONTH = "NEXTMONTH",
    LASTYEAR = "LASTYEAR",
    THISYEAR = "THISYEAR"
};
